export default __webpack_public_path__ + "static/media/LincolnHeritage.d45d641d.svg";